export const championsData = [
  {
    id: 'anamika-silver',
    name: 'Anamika',
    fullName: 'Shooter Anamika',
    title: 'Silver Medal Winner',
    event: 'Open Shooting Championship',
    category: '10m Air Pistol / Precision Target Shooting',
    medal: 'Silver Medal',
    medalType: 'silver',
    medalIcon: '🥈',
    badge: 'Silver Medalist',
    badgeColor: 'from-slate-200 via-zinc-400 to-slate-200 text-black border-slate-300',
    glowColor: 'rgba(203, 213, 225, 0.4)',
    accentGradient: 'from-slate-400/20 via-zinc-800/60 to-black',
    image: '/images/anamikaCSA.jpg',
    aspect: 'aspect-[3/4]',
    highlight: '2nd Place Podium Finish in Open Championship',
    quote: 'Your Hard Work, Focus & Determination Have Made Us All Proud!',
    motto: 'Your Dedication Today, Your Success Tomorrow!',
    pillars: ['Training', 'Discipline', 'Focus', 'Success'],
    date: 'Championship 2024-25',
    academyContact: '9653524055',
    description: 'Delivered an exceptional high-precision performance under tournament pressure to clinch the prestigious Silver Medal in the Open Shooting Championship.',
    tags: ['Silver Medalist', '10m Air Pistol', 'Podium Finish']
  },
  {
    id: 'abhishek-bronze',
    name: 'Abhishek',
    fullName: 'Shooter Abhishek',
    title: 'Bronze Medal Winner',
    event: 'Open Shooting Championship',
    category: '10m Precision Marksmanship',
    medal: 'Bronze Medal',
    medalType: 'bronze',
    medalIcon: '🥉',
    badge: 'Bronze Medalist',
    badgeColor: 'from-amber-600 via-orange-400 to-amber-700 text-white border-amber-500/40',
    glowColor: 'rgba(217, 119, 6, 0.4)',
    accentGradient: 'from-amber-600/20 via-zinc-800/60 to-black',
    image: '/images/abhishekCSA.jpg',
    aspect: 'aspect-[3/2]',
    highlight: 'Podium Triumph in Open Shooting Championship',
    quote: 'Your dedication, discipline and hard work have brought you this success. We are proud of you!',
    motto: 'Keep Aiming... Keep Shining!',
    pillars: ['Focus', 'Discipline', 'Dedication', 'Success'],
    date: 'Championship 2024-25',
    academyContact: '9653524055',
    description: 'Demonstrated outstanding accuracy, calm composure, and disciplined technique to conquer the podium with a Bronze Medal victory in the Open Shooting Championship.',
    tags: ['Bronze Medalist', 'Pistol & Rifle', 'Open Championship']
  },
  {
    id: 'prenational-qualifier',
    name: 'National Pathway Star',
    fullName: 'Chaitanya Rising Champion',
    title: 'Qualified For The Pre-National',
    event: 'National Shooting Championship Pathway (SAI / ISSF)',
    category: '10m Air Rifle / Olympic Standard Range',
    medal: 'Pre-National Qualifier',
    medalType: 'national',
    medalIcon: '🎯',
    badge: 'Pre-National Qualifier',
    badgeColor: 'from-amber-400 via-yellow-300 to-amber-500 text-black border-yellow-400',
    glowColor: 'rgba(250, 204, 21, 0.45)',
    accentGradient: 'from-yellow-500/20 via-blue-900/40 to-black',
    image: '/images/preinternationalCSA.jpg',
    aspect: 'aspect-[3/4]',
    highlight: 'Official Pre-National Qualification on SAI / ISSF Range',
    quote: 'Has Qualified For The Pre National — A Big Step Towards the National Stage!',
    motto: 'Keep Aiming... Keep Achieving!',
    pillars: ['Focus', 'Dedication', 'Hard Work', 'Passion'],
    date: 'National Pathway 2024-25',
    academyContact: '9653524055',
    description: 'Achieved the benchmark qualifying score at the Sports Authority of India (SAI) target range, advancing directly into the Pre-National shooting circuit.',
    tags: ['Pre-National Stage', 'SAI Target Range', 'Olympic Pathway']
  }
];

export const academyHighlights = [
  { value: '100%', label: 'Dedicated Mentorship', detail: '1-on-1 Personalized Coaching' },
  { value: '2+', label: 'Championship Medals', detail: 'Silver & Bronze in Open Meets' },
  { value: 'SAI', label: 'Pre-National Qualified', detail: 'Official National Pathway' },
  { value: 'NRAI', label: 'Certified Coaches', detail: 'Olympic-Standard Electronic Targets' }
];
